/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCustomQuestionsQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int'];
  skip: Types.Scalars['Int'];
}>;


export type GetCustomQuestionsQuery = { getCustomQuestions: { count: number, questions: Array<{ id: number, isUsed: boolean, name: string, type: Types.QuestionType, choices: Array<{ id: number, name: string, satisfaction_value: number }> }> } };


export const GetCustomQuestionsDocument = gql`
    query GetCustomQuestions($limit: Int!, $skip: Int!) {
  getCustomQuestions(limit: $limit, skip: $skip) {
    count
    questions {
      id
      isUsed
      name
      type
      choices {
        id
        name
        satisfaction_value
      }
    }
  }
}
    `;

/**
 * __useGetCustomQuestionsQuery__
 *
 * To run a query within a React component, call `useGetCustomQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomQuestionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetCustomQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomQuestionsQuery, GetCustomQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomQuestionsQuery, GetCustomQuestionsQueryVariables>(GetCustomQuestionsDocument, options);
      }
export function useGetCustomQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomQuestionsQuery, GetCustomQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomQuestionsQuery, GetCustomQuestionsQueryVariables>(GetCustomQuestionsDocument, options);
        }
export type GetCustomQuestionsQueryHookResult = ReturnType<typeof useGetCustomQuestionsQuery>;
export type GetCustomQuestionsLazyQueryHookResult = ReturnType<typeof useGetCustomQuestionsLazyQuery>;
export type GetCustomQuestionsQueryResult = Apollo.QueryResult<GetCustomQuestionsQuery, GetCustomQuestionsQueryVariables>;